import React from 'react'
import { Modal, FormGroup, Radio } from 'react-bootstrap'

class ModalOpenRankingSession extends React.Component {
  state = {
    value: null
  }

  handleChange = (value) => {
    this.setState({
      value
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.onSubmit(this.state.value);
  }

  handleClose = () => {
    this.setState({
      value: null
    })
    this.props.onCancel();
  }

  render() {
    const { showModal, runSlug } = this.props
    const { value } = this.state;

    return (
      <Modal show={showModal} onHide={this.handleClose} className="modal-open-ranking-session">
        <Modal.Header closeButton>
          <Modal.Title>
            Student Ranking Notifications
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={this.handleSubmit}>
          <Modal.Body>
            <p className="mt-1">
              Each time you open a ranking session you can choose to have Cognomos send an email to students inviting them to rank their classes.
            </p>
            <FormGroup controlId="formControlsOpenRankingSessionRadioValue">
              <Radio name="radioGroup" onChange={() => this.handleChange(true)} checked={value}>
                <p className="color-black">
                  Yes, automatically email all students inviting them to rank classes.
                </p>
              </Radio>
              <Radio name="radioGroup" onChange={() => this.handleChange(false)}>
                No, do not email my students.
              </Radio>
            </FormGroup>
            <p className="mt-1">
              You can also manually direct students to their ranking session URL:
              <a href={`https://app.cognomos.com/rank/${runSlug}`}> {`https://app.cognomos.com/rank/${runSlug}`}</a>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="buttonsSpaceBetween">
              <button className="btn btn-ter" type="button" onClick={this.handleClose}>
                Cancel
              </button>
              <button className="btn" type="submit" disabled={ value === null }>
                {this.props.confirmButtonTitle}
              </button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default ModalOpenRankingSession


// WEBPACK FOOTER //
// ./src/components/runs/OpenRankingSessionModal.js